import React from 'react';
import { NavLink } from 'react-router-dom';
import { Container, Row, Col } from 'react-bootstrap';
import Navbar from './Navbar';
import Footer from './Footer';
import MetaTags from './MetaTags';
import NotFoundBanner from './images/bg-page-title.webp';
import { NoDataSvg } from './404no-data';
import './Stlye.css';

const NotFoundPage = () => (
  <div className="not_found_page">
    <MetaTags
      title="Page Not Found | Smart Resources QLD"
      description="The page you are looking for could not be found. Return to the Smart Resources QLD homepage or browse our services."
      robots="noindex, nofollow"
      Canonical="https://smartresourcesqld.com.au/404"
      ogImage={NotFoundBanner}
      ogTitle="Page Not Found | Smart Resources QLD"
    />

    <Navbar />

    <section
      className="innr_banner"
      style={{ backgroundImage: `url(${NotFoundBanner})` }}
    >
      <div className="page_title_innr">
        <div className="page_title">Page Not Found</div>
        <ul className="bread_crumb">
          <li>
            <NavLink to="/">Home</NavLink>
          </li>
          <li>404</li>
        </ul>
      </div>
    </section>

    <section className="pricing servinnrbg not_found_section">
      <div className="servinnng_middle">
        <Container>
          <Row className="align-items-center g-4">
            <Col lg="5" md="12" sm="12">
              <div className="not_found_illustration">
                <NoDataSvg />
              </div>
            </Col>

            <Col lg="7" md="12" sm="12">
              <div className="global_left serv_innr_heading not_found_content">
                <h1>Sorry, we couldn&apos;t find that page</h1>
                <p>
                  The page you are looking for may have been moved, renamed, or
                  is temporarily unavailable.
                </p>
                <p>
                  Use the buttons below to return to the homepage or explore our
                  consulting services.
                </p>

                <div className="not_found_actions">
                  <NavLink
                    className="not_found_btn not_found_btn_primary"
                    to="/"
                    onClick={() => window.scrollTo(0, 0)}
                  >
                    Back to Home
                  </NavLink>
                  <NavLink
                    className="not_found_btn not_found_btn_secondary"
                    to="/operations"
                    onClick={() => window.scrollTo(0, 0)}
                  >
                    View Services
                  </NavLink>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </section>

    <Footer />
  </div>
);

export default NotFoundPage;
